import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false); // 👈 Hamburger toggle
  const [showSessionExpiredPopup, setShowSessionExpiredPopup] = useState(false);
  const [showLogoutConfirmPopup, setShowLogoutConfirmPopup] = useState(false);
  const [showNewFIRConfirmPopup, setShowNewFIRConfirmPopup] = useState(false);

  const role = localStorage.getItem('role');
  const isAdvocate = role === 'Advocate';
  const isAdmin = role === 'admin';
  const firstName = localStorage.getItem('firstName');

  const pathname = location.pathname;
  const isHomePage = pathname === "/";
  const isAboutPage = pathname === "/about";
  const isTermsPage = pathname === "/terms";
  const isPrivacyPage = pathname === "/privacy";
  const isLoginPage = pathname === "/login";
  const isProfilePage = pathname === "/profile";
  const isRegisterPage = pathname === "/register";
  const isAnalysisPage = pathname === "/investigate/fir" || pathname.startsWith("/fir/");
  const isUploadPage = pathname === "/upload";
  const isDraftPage = pathname === "/draft";
  const isMyCasesPage = pathname === "/mycases" || pathname === "/fir/complaint";
  const isFIRPage = pathname === "/fir";
  const isBlogsPage = pathname === "/blogs";
  const isInstallAppPage = pathname === "/app";
  const isAdminPage = pathname === "/admin";

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const logout = () => {
    localStorage.clear();
    navigate('/');
  };

  const handleLogoutClick = (e) => {
    e.preventDefault();
    setShowLogoutConfirmPopup(true);
    setMenuOpen(false); // Close menu on logout confirm prompt
  };

  const handleNewFIRClick = (e) => {
    e.preventDefault();
    if (isFIRPage) setShowNewFIRConfirmPopup(true);
    else navigate('/upload');
    setMenuOpen(false); // Close menu
  };

  const checkJwtValidity = () => {
    const jwtToken = localStorage.getItem('jwtToken');
    if (jwtToken) {
      try {
        const decodedToken = jwtDecode(jwtToken);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          setShowSessionExpiredPopup(true);
        } else {
          const currentRole = localStorage.getItem('role');
          const currentFirstName = localStorage.getItem('firstName');
          if (decodedToken.role !== currentRole || decodedToken.firstName !== currentFirstName) {
            localStorage.setItem('role', decodedToken.role);
            localStorage.setItem('firstName', decodedToken.firstName);
          }
        }
      } catch (err) {
        logout();
      }
    } else if (isAnalysisPage || isMyCasesPage || isFIRPage) {
      setShowSessionExpiredPopup(true);
    }
  };

  useEffect(() => {
    checkJwtValidity();
    const intervalId = setInterval(checkJwtValidity, 15 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  const hostname = window.location.hostname.toLowerCase();
  const isI4C = hostname === "i4c.legalapp.in";
  return (
    <div>
      <nav className="menu-bar no-print navbar">
        <div className="menu-title">
          <Link to="/" className="menu-item">LegalApp</Link>
          {isI4C && (
            <span style={{ marginLeft: '0px', color: '#ff4d00ff', fontSize: '22px' }}>I4C</span>
          )}
        </div>

        {/* Hamburger icon - hidden on the home page, which has its own Continue/Desktop/Mobile navigation */}
        {!isHomePage && (
          <div className="hamburger" onClick={toggleMenu}>
            <div></div>
            <div></div>
            <div></div>
          </div>
        )}

        <div className={`menu-items ${menuOpen ? "active" : ""}`} style={{ marginRight: '30px' }}>
          {/* <Link to="/about" hidden={isAnalysisPage || firstName || isTermsPage || isPrivacyPage} className={`menu-item ${isAboutPage ? "selected" : ""}`}>
            About
          </Link> */}
          {/* <Link to="/blogs" hidden={isAnalysisPage || firstName || isTermsPage || isPrivacyPage} className={`menu-item ${isBlogsPage ? "selected" : ""}`}>
            Blogs
          </Link> */}
          {/* <Link to="/app" hidden={isAnalysisPage || firstName || isTermsPage || isPrivacyPage} className={`menu-item ${isInstallAppPage ? "selected" : ""}`}>
            Install App
          </Link> */}
          <Link to="/login" hidden={isAnalysisPage || firstName || isTermsPage || isPrivacyPage} className={`menu-item ${isLoginPage ? "selected" : ""}`}>
            Login
          </Link>
          {firstName && !isTermsPage && !isPrivacyPage && (
            <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
              Welcome, {isAdvocate ? 'Advocate ' : ''}{firstName}
            </div>
          )}
          {firstName && (
            <>
              <Link to="/profile" hidden={isTermsPage || isPrivacyPage} className={`menu-item ${isProfilePage ? "selected" : ""}`}>
                Update Profile
              </Link>
              <Link to="/mycases" hidden={isTermsPage || isPrivacyPage} className={`menu-item ${isMyCasesPage ? "selected" : ""}`}>
                My Cases
              </Link>
              <Link hidden={isTermsPage || isPrivacyPage || !isAnalysisPage} className={`menu-item ${isAnalysisPage ? "selected" : ""}`}>
                FIR Analysis
              </Link>
              {isAdmin && (
                <Link to="/draft" hidden={isTermsPage || isPrivacyPage} className={`menu-item ${isDraftPage ? "selected" : ""}`}>
                  Draft FIR
                </Link>
              )}
              <Link to="/upload" onClick={handleNewFIRClick} hidden={isTermsPage || isPrivacyPage} className={`menu-item ${isUploadPage ? "selected" : ""}`}>
                Upload FIR
              </Link>
              {isAdmin && (
                <Link to="/admin" hidden={isTermsPage || isPrivacyPage} className={`menu-item ${isAdminPage ? "selected" : ""}`}>
                  Admin
                </Link>
              )}
              <Link to="/login" onClick={handleLogoutClick} hidden={isTermsPage || isPrivacyPage} className="menu-item">
                Logout
              </Link>
            </>
          )}
        </div>
      </nav>

      {/* Popups (session expired, logout, confirm new FIR) same as before */}
      {showSessionExpiredPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2>Session Expired</h2>
            <p>Your session has expired. Please log in again to continue.</p>
            <div className="popup-buttons">
              <button className="submit-popup-button" onClick={() => { setShowSessionExpiredPopup(false); logout(); }}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {showLogoutConfirmPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2>Logout Confirmation</h2>
            <p>Are you sure you want to log out?</p>
            <div className="popup-buttons">
              <button className="submit-popup-button" onClick={() => setShowLogoutConfirmPopup(false)}>Cancel</button>
              <button className="cancel-button" onClick={logout}>Logout</button>
            </div>
          </div>
        </div>
      )}

      {showNewFIRConfirmPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2>Confirm</h2>
            <p>Do you want to analyse a new FIR?</p>
            <div className="popup-buttons">
              <button className="cancel-button" onClick={() => setShowNewFIRConfirmPopup(false)}>Cancel</button>
              <button className="submit-popup-button" onClick={() => { setShowNewFIRConfirmPopup(false); navigate('/upload'); }}>
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
